import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { AUTEST_TEST_CASE } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
import { doubleEncode } from '../../../../Utils/Encode/UrlHelper';
/**
 * list Tests.
 * @returns {Promise} - A promise that resolves with the list of Tests or rejects with an error.
 * @param props
 */
export const listTestCase = async ({
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const { accessToken } = getTokensFromStorage();

  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST_CASE.replace('{testId}', "''")}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    tests: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Test.
 * @returns {Promise} - A promise that resolves with the creation of test or rejects with an error.
 * @param data
 */
export const createTestCase = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST_CASE.replace('{testId}', doubleEncode(data?.uc_ossi_app_test_id))}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Test.
 * @returns {Promise} - A promise that resolves with the update of test or rejects with an error.
 * @param data
 */
export const updateTestCase = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST_CASE.replace('{testId}', doubleEncode(data?.uc_ossi_app_test_id))}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Test.
 * @returns {Promise} - A promise that resolves with the update of test or rejects with an error.
 * @param data
 */
export const deleteTestCase = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST_CASE.replace('{testId}', doubleEncode(data?.uc_ossi_app_test_id))}/${doubleEncode(data?.uc_ossi_test_case_id)}?tenant_id=${encodeURIComponent(data?.tenant_id)}&uc_ossi_prod_id=${encodeURIComponent(data?.uc_ossi_prod_id)}&uc_ossi_app_test_id=${encodeURIComponent(data?.uc_ossi_app_test_id)}&uc_ossi_test_case_id=${encodeURIComponent(data?.uc_ossi_test_case_id)}&uc_env_id=${encodeURIComponent(data?.uc_env_id)}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * get copy Test Case.
 * @returns {Promise} - A promise that resolves with the update of Test Case or rejects with an error.
 * @param data
 */
export const getCopyTestCase = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST_CASE.replace('{testId}', doubleEncode(data?.uc_ossi_app_test_id))}/Copy?tenant_id=${data?.tenant_id}&uc_ossi_test_case_id=${encodeURIComponent(data?.uc_ossi_test_case_id)}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
/**
 * post copy Test and save in DB.
 * @returns {Promise} - A promise that resolves with the create of Test Case or rejects with an error.
 * @param data
 */
export const postCopyTestCase = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${AUTEST_TEST_CASE.replace('{testId}', doubleEncode(data?.uc_ossi_app_test_id))}/Copy`,
    method: 'POST',
    body: data,
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
